import React, { useState } from 'react';
import { Helmet } from "react-helmet";
import { backArrow } from "./svg";
import { BreadcrumbsItem } from "react-breadcrumbs-dynamic";
import {
    SiriDimentionWrapper,
    SiriDimentionCard,
    Header,
    NumberWrapper,
    Number,
    NumberTextWrapper,
    Row,
    BodyRow,
    Column1,
    Column2,
    Column3,
    TBodyRow,
    TBodyCol,
    Status,
    ValidateBtn,
    ReValidateBtn,
    CapabilityBtn,
    ValidatePopWrapper,
    ValidatePopWrap,
    ValidatePopCard,
    ButtonWrap,
    SiriMobileTitleContainer,
} from './siri-dimention-style.js';

export const SiriDimension = () => {
    const [isValidatePop, setIsValidatePop] = useState(false);
    const [isReValidatePop, setIsReValidatePop] = useState(false);
    const [data, setData] = useState({
        name: 'Vertical Integration',
        status: 'inprogress',
        dimension: 1,
        isValidated: 0,
        list: [
            {
                id: 1,
                band: 'Band 0',
                band_name: 'Undefined',
                band_criteria: [
                    {
                        id: 1,
                        name: 'No SOPs',
                        capability: 0, /*0 for has not and 1 for has*/
                        answer: 0,
                        selcted: null
                    },
                    {
                        id: 2,
                        name: 'No clear documentation',
                        capability: 0, /*No clear documentation*/
                        answer: 0,
                        selcted: null
                    },
                    {
                        id: 3,
                        name: 'No clear documentation ',
                        capability: 0, /*No clear documentation*/
                        answer: 0,
                        selcted: null
                    },
                    {
                        id: 4,
                        name: 'No ISO certificates',
                        capability: 0, /*No clear documentation*/
                        answer: 0,
                        selcted: null
                    },
                    {
                        id: 5,
                        name: 'No ERP',
                        capability: 0, /*No clear documentation*/
                        answer: 0,
                        selcted: null
                    },
                ]
            },
            {
                id: 2,
                band: 'Band 1',
                band_name: 'Defined',
                band_criteria: [
                    {
                        id: 1,
                        name: 'SOPs with analogue tools',
                        capability: 0, /*0 for has not and 1 for has*/
                        answer: 0,
                        selcted: null
                    },
                    {
                        id: 2,
                        name: 'There is a clear documentation',
                        capability: 0, /*No clear documentation*/
                        answer: 0,
                        selcted: null
                    },
                    {
                        id: 3,
                        name: 'ISO certified',
                        capability: 0, /*No clear documentation*/
                        answer: 0,
                        selcted: null
                    },
                    {
                        id: 4,
                        name: 'Excel Sheets',
                        capability: 0, /*No clear documentation*/
                        answer: 0,
                        selcted: null
                    },
                    {
                        id: 5,
                        name: 'Records',
                        capability: 0, /*No clear documentation*/
                        answer: 0,
                        selcted: null
                    },
                    {
                        id: 6,
                        name: 'Paper',
                        capability: 0, /*No clear documentation*/
                        answer: 0,
                        selcted: null
                    },
                ]
            },
            {
                id: 2,
                band: 'Band 2',
                band_name: 'Digital',
                band_criteria: [
                    {
                        id: 1,
                        name: 'Has an ERP systems',
                        capability: 0, /*0 for has not and 1 for has*/
                        answer: 0,
                        selcted: null
                    },
                ]
            },
        ]
    }
    )

    const yesValidateFunction = () => {
        setIsValidatePop(false);
        setData(prv => {
            return {
                ...prv,
                isValidated: 1
            }
        });
    }

    const yesReValidateFunction = () => {
        setIsReValidatePop(false);
        setData(prv => {
            return {
                ...prv,
                isValidated:0
            }
        })
    }

    const handleCapability = (el, brandId, criteria_name, capability_value) => {
        let tmpActiveBtn = el.target.parentElement.querySelector('.active');
        if (!el.target.classList.contains('active')) {
            tmpActiveBtn.classList.remove('active');
            el.target.classList.add('active');
        } else if (tmpActiveBtn) {
            el.target.classList.add('active');
        }
    }
    return (
        <>
            <BreadcrumbsItem to="/">Home</BreadcrumbsItem>
            <BreadcrumbsItem to="/siri-assessment">SIRI Assessment</BreadcrumbsItem>
            <BreadcrumbsItem to="#">Dimension 1: Vertical Integration</BreadcrumbsItem>
            <Helmet>
                <title>Siri Dimension | SmarterChains</title>
                <meta name="description" content="Siri Dimension" />
                <meta name="viewport" content="width=device-width, initial-scale=1" />
            </Helmet>
            <SiriDimentionWrapper data-component="SiriDimentionWrapper">

                <SiriMobileTitleContainer data-component="SiriMobileTitleContainer">
                    <button className="back-icon" dangerouslySetInnerHTML={{ __html: backArrow }}></button>
                    <span>{data.name}</span>
                </SiriMobileTitleContainer>
                <SiriDimentionCard data-component="SiriDimentionCard">
                    <Header data-component="Header">
                        <Row data-component="Row" align="center">
                            <Column1 data-component="Column1" align="center">
                                <NumberWrapper data-component="NumberWrapper">
                                    <Number data-component="Number">1</Number>
                                    <NumberTextWrapper data-component="NumberTextWrapper">
                                        <p className='dull-title'>Dimension {data.dimension}</p>
                                        <p className='title'>{data.name}</p>
                                    </NumberTextWrapper>
                                </NumberWrapper>
                                {/* NumberWrapper end */}
                            </Column1>

                            {/* column1 end  */}

                            <Column2 data-component="Column2" align="center">
                                <Status status={data.isValidated == 1 ? 'validated': data.status}>
                                    {data.isValidated == 1 ? 'VALIDATED' : data.status === 'inprogress' ? 'In progress' : data.status === 'validated' ? 'Validated' : 'To Do'}
                                </Status>
                            </Column2>
                            {/* column2 end  */}
                            {data.isValidated == 0 ?
                                <ValidateBtn data-component="ValidateBtn" onClick={() => setIsValidatePop(true)}>
                                    Validate <span>Dimension</span>
                                </ValidateBtn>
                                :
                                <ReValidateBtn data-component="ReValidateBtn" onClick={() => setIsReValidatePop(true)}>
                                    Re-validate <span>Dimension</span>
                                </ReValidateBtn>}
                            <Column3 data-component="Column3" align="center"> </Column3>
                            {/* column3 end  */}

                        </Row>
                        {/*  Row end */}
                    </Header>
                    {/* Header end */}

                    <Row data-component="Row">
                        <Column1 data-component="Column1" borderBottom={true} align="center">
                            <div className='header-col-title col-m1'>Band</div>
                            <div className='header-col-title col-m2'>BAND NAME</div>
                        </Column1>

                        {/* column1 end  */}

                        <Column2 data-component="Column2" borderBottom={true} align="center">
                            <div className='header-col-title col-m1' >THE MAIN BAND CRITERIA</div>
                            <div className='header-col-title col-m2'>CAPABILITY</div>
                        </Column2>
                        {/* column2 end  */}
                        <Column3 data-component="Column3" align="center"></Column3>
                        {/* column3 end  */}
                    </Row>
                    {/*  Row end */}
                    {data.list?.map((item, index) => (
                        <BodyRow data-component="Row" key={index}>
                            <Column1 data-component="Column1">
                                <TBodyCol data-component="TBodyCol">
                                    <div className='col-m1'>
                                        <p className='md-text'>{item.band}</p>
                                        <p className='sm-text'>{item.band}:</p>
                                        <p className='sm-text turncate'>{item.band_name}</p>
                                    </div>
                                    <div className='col-m2'> {item.band_name}</div>
                                </TBodyCol>
                            </Column1>

                            {/* column1 end  */}

                            <Column2 data-component="Column2">
                                <TBodyRow data-component="TBodyRow">
                                    {item.band_criteria.map((criteria, c_ind) => (
                                        <TBodyCol data-component="TBodyCol" borderBottom={true} key={c_ind}>
                                            <div className='col-m1'>
                                                <p>
                                                    {criteria.name}
                                                </p>
                                                {criteria.selcted !== null ? <i className='sm-edited-txt'>Edited - Originally: {criteria.answer === 0 ? "HAS NOT" : 'HAS'}</i> : ''}
                                            </div>
                                            <div className='col-m2'>
                                                {criteria.selcted !== null ? <p className='edited-txt'>Edited</p> : ''}
                                                <CapabilityBtn disabled={data.isValidated == 1} className={(data.isValidated == 1 && criteria.selcted === 1) ? 'inactive' : criteria.selcted === 1 ? 'active' : ''} data-component="CapabilityBtn" onClick={(e) => handleCapability(e, item.id, criteria.name, 1)}>
                                                    Has
                                                </CapabilityBtn>
                                                <CapabilityBtn disabled={data.isValidated == 1} className={(data.isValidated == 1 && (criteria.selcted == 0 || criteria.selcted == null))? 'inactive' : criteria.selcted === 0 || criteria.selcted === null ? 'active' : ''} data-component="CapabilityBtn" onClick={(e) => handleCapability(e, item.id, criteria.name, 0)}>
                                                    Has Not
                                                </CapabilityBtn>
                                                {criteria.selcted !== null ? <p className='originally-txt'>Originally: {criteria.answer === 0 ? "HAS NOT" : 'HAS'}</p> : ''}
                                            </div>
                                        </TBodyCol>
                                    ))

                                    }
                                </TBodyRow>
                            </Column2>
                            {/* column2 end  */}
                            <Column3 data-component="Column3"></Column3>
                            {/* column3 end  */}
                        </BodyRow>
                    ))}
                    {/*  Row end */}

                </SiriDimentionCard>
                {/*SiriDimentionCard end  */}
                {/* Revalidate and validate popups */}
                {isValidatePop ?
                    <ValidatePopWrapper data-component="ValidatePopWrapper">
                        <ValidatePopWrap data-component="ValidatePopWrap">
                            <ValidatePopCard data-component="ValidatePopCard">
                                <h3>Are you sure to validate Dimension?</h3>
                                <p>All the capabilities will be updated and can be downloaded</p>
                                <ButtonWrap data-copmponent="ButtonWrap">
                                    <button className="cancel-btn" onClick={() => setIsValidatePop(false)}>Cancel</button>
                                    <button className="validate-btn" onClick={() => yesValidateFunction()}>Yes, validate</button>
                                </ButtonWrap>
                            </ValidatePopCard>
                        </ValidatePopWrap>
                    </ValidatePopWrapper>
                    : ''}
                {isReValidatePop ?
                    <ValidatePopWrapper data-component="ValidatePopWrapper">
                        <ValidatePopWrap data-component="ValidatePopWrap">
                            <ValidatePopCard data-component="ValidatePopCard">
                                <h3>Are you sure to re-validate Dimension?</h3>
                                <p>You can make changes and update capabilities.</p>
                                <ButtonWrap data-copmponent="ButtonWrap">
                                    <button className="cancel-btn" onClick={() => setIsReValidatePop(false)}>Cancel</button>
                                    <button className="validate-btn" onClick={() => yesReValidateFunction()}>Yes, re-validate</button>
                                </ButtonWrap>
                            </ValidatePopCard>
                        </ValidatePopWrap>
                    </ValidatePopWrapper>
                    : ''}
            </SiriDimentionWrapper >
        </>
    )
}